import { createSlice } from "@reduxjs/toolkit";
import {getAllMealtimes, GetTotalMealsKpisGrid, GetTotalMealsKpisList} from "./FoodieOrdersApi";
import {ResponseApi} from "../BaseApi";

/**
 * @Author      Jhovanny Fragoso Marquez
 * @JobTitle    Frontend Developer
 * @Email       jfragoso@ibl.mx
 */


const FoodieOrdersSlice = createSlice({
    name: 'foodieMealTimes',
    initialState: {
        mealtimes: [],
        loading: false,
        error: null,
        getTotalMealsKpisList: null,
        getTotalMealsKpisGrid: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllMealtimes.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getAllMealtimes.fulfilled, (state, action) => {
                state.loading = false;
                state.mealtimes = action.payload.data || [];
            })
            .addCase(getAllMealtimes.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(GetTotalMealsKpisList.fulfilled, (state, { payload }) => {
                state.getTotalMealsKpisList = ResponseApi(payload);
            })
            .addCase(GetTotalMealsKpisGrid.fulfilled, (state, { payload }) => {
                state.getTotalMealsKpisGrid = ResponseApi(payload);
            });
    },
})

export default FoodieOrdersSlice.reducer;
